export default __webpack_public_path__ + "static/media/java.223c104e.svg";